import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanMatch, Router } from '@angular/router';
import { HTTP_AP_CompanyClientUISettings, HTTP_CP_CompanyClientUISettings } from '@api-new/companyservice';
import { Store } from '@ngrx/store';
import { paths } from '@platform/paths';
import { selectCompany } from '@shared/store/company/company.selectors';

export type CompanyClientUISettingsKey = Exclude<
  keyof HTTP_CP_CompanyClientUISettings,
  'id' | 'companyId' | 'consentScreenText' | 'inactivityTimeoutInMinutes' | 'inactivityTimeoutRedirectUrl'
>;

@Injectable({
  providedIn: 'root',
})
export class CompanyClientUiSettingsService implements CanMatch {
  private readonly globalStore = inject(Store);
  private readonly router = inject(Router);

  private companyClientUISettings: HTTP_AP_CompanyClientUISettings | undefined;

  constructor() {
    this.globalStore.select(selectCompany).subscribe((company) => {
      this.companyClientUISettings = company?.companyClientUISettings;
    });
  }

  getCompanyUISettingsFeature(key: CompanyClientUISettingsKey): boolean {
    return this.companyClientUISettings ? this.companyClientUISettings[key] : false;
  }

  canMatch(route: ActivatedRouteSnapshot): boolean {
    const routeCompanyFeature = route.data.companyUISettings;

    if (this.getCompanyUISettingsFeature(routeCompanyFeature)) {
      return true;
    }
    void this.router.navigate([paths.PLATFORM, paths.platform.DASHBOARD]);

    return false;
  }
}
